import { GlobalState } from '../../../redux/store';

export const statusSelector = (state: GlobalState) => state.vendors.status;
